// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nDOk","placeholdersHeader":"styles_placeholdersHeader__12xlB","editorStyle":"styles_editorStyle__3zetm","placeholdersBox":"styles_placeholdersBox__E3Kdw"};